import { render, staticRenderFns } from "./InputNumber.vue?vue&type=template&id=5b229ae3&"
import script from "./InputNumber.vue?vue&type=script&lang=js&"
export * from "./InputNumber.vue?vue&type=script&lang=js&"
import style0 from "./InputNumber.vue?vue&type=style&index=0&id=5b229ae3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports